export default __webpack_public_path__ + "static/media/BlogBanner.6fec55c1.jpg";